export default __webpack_public_path__ + "static/media/Error.bfaf6e25.jpg";